import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box, Button, Typography, useTheme } from "@mui/material";
import { CreateNewLayoutButton } from "./dialogs/CreateNewLayoutButton";
import { IStoreState, useAppDispatch, useAppSelector } from "../../redux";
import { useAuthProvider, useOutletContext } from "../../providers";
import { fetchSingleOutletLayoutsAsync, ITablesLayout } from "../../redux/tables";
import { TABLES_ROUTE } from "./Tables.constants";
import { useNavigate, useParams } from "react-router-dom";
import { TabsList } from "../../Components/Tab/Tab";
import { a11yProps } from "../../Components/Tab/utils";

interface TabData {
    id: number;
    label: string;
    content: string;
}

export default function TableLayoutTabs() {
    const { uuid: layoutUUID } = useParams<{ uuid?: string }>();
    const navigate = useNavigate()
    const dispatch = useAppDispatch();
    const { outlet_details: { outlet_uuid, outlet_name } } = useOutletContext()
    const {authInfo: {user: {role_value}}} = useAuthProvider()
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';

    const {
        data: multipleDataArray,
    } = useAppSelector((storeState: IStoreState) => storeState.tables.layouts_list_without_tables);


    const [tabs, setTabs] = useState<ITablesLayout[]>([]);
    const [activeTab, setActiveTab] = useState<string | null>(null);


    useEffect(() => {
        if (!outlet_uuid) return
        dispatch(fetchSingleOutletLayoutsAsync({outlet_uuid, exclude_tables: true}))
    }, [outlet_uuid])


    useEffect(() => {
        if (multipleDataArray.length > 0) {
            setTabs(multipleDataArray)
            navigate(`${TABLES_ROUTE}/manage/${multipleDataArray[0].layout_uuid}`);
        }
    }, [multipleDataArray])

    useEffect(() => {
        if (!layoutUUID) return
        setActiveTab(layoutUUID);
    }, [layoutUUID])

    const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
        navigate(`${TABLES_ROUTE}/manage/${newValue}`);
    };

    const onAddLayoutSuccess = (newLayout: ITablesLayout) => {
        setTabs([...multipleDataArray, newLayout])
        navigate(`${TABLES_ROUTE}/manage/${newLayout.layout_uuid}`);
    };

    if (tabs.length > 0) {
        return (
            <Box sx={{ width: "100%", pb: 2 }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs 
    value={activeTab} 
    onChange={handleTabChange} 
    textColor="inherit"
    indicatorColor="secondary"
    sx={{
        ".MuiTabs-flexContainer": {
            alignItems: "center"
        },
        "& .MuiTab-root": {
            color: theme.palette.text.primary,
        },
        "& .MuiTab-root.Mui-selected": {
            color: theme.palette.text.primary,
        }
    }}
>
    {tabs.map((tab, index) => (
        <Tab key={tab.outlet_uuid} label={tab.layout_name} value={tab.layout_uuid} {...a11yProps(index)} />
    ))}
    {role_value === "ADMIN" && <CreateNewLayoutButton onSuccess={onAddLayoutSuccess} />}
</Tabs>
                </Box>

                {/* <Box sx={{ mt: 2, p: 2, border: "1px solid #ddd", borderRadius: 2 }}>
                <Typography>{activeTab}</Typography>
            </Box> */}
            </Box>
        );
    }

    return <></>
}
